import * as React from "react";
import { useContext } from "react";
import StreamsContext from "contexts/StreamsContext";
import FilterPreviewResults from "components/event-definitions/event-definition-types/FilterPreviewResults";
import FilterPreview from "./FilterPreview";
const FilterPreviewContainer = ({ eventDefinition }) => {
  const streams = useContext(StreamsContext);
  return (streams == null ? void 0 : streams.length) ? /* @__PURE__ */ React.createElement(FilterPreview, { config: eventDefinition == null ? void 0 : eventDefinition.config }) : /* @__PURE__ */ React.createElement(FilterPreviewResults, null, "Unable to preview filter, user does not have access to any streams.");
};
export default FilterPreviewContainer;
